/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: ShippersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { ShippersData, ShippersService }  from './Shippers.service';



@Component({
  template: require('./ShippersEdit.component.html'),
  providers: [ShippersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ShippersEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objShippers: ShippersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private ShippersService: ShippersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objShippers = new ShippersData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.ShippersService.getByID(+params['id']))
		.switchMap((params: Params) => this.ShippersService.getByID(params['id']))
		.subscribe((item: ShippersData) => this.objShippers = item);
		this.getLookups();
	}

	updateShippers() {
		this.ShippersService.updateShippersData(this.objShippers)
			.subscribe(record => this.router.navigate(['/Shippers']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Shippers record updated successfully...', 'Edit Shippers');
					console.log('Shippers record updated successfully...'); 
				}
			);
	}
  
	deleteShippers(id: string) {
		if (window.confirm('Are you sure you want to delete this Shippers?') == true) 
		{
			this.ShippersService.deleteShippers(this.objShippers.ShipperID.toString())
			.subscribe(record => this.router.navigate(['/Shippers']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Shippers record deleted successfully...', 'Delete Shippers');
					console.log('Shippers record deleted successfully...'); 
				}
			);
		}
	}

	gotoShippers() {
		let Id = this.objShippers ? this.objShippers.ShipperID : null;
		this.router.navigate(['/Shippers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/ShippersEdit.component.ts